import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { ownerApi } from "@/lib/api";
import { Spinner, EmptyState } from "@/components/common/States";

export default function OwnerBlocked() {
  const queryClient = useQueryClient();
  const query = useQuery({ queryKey: ["ownerBlocked"], queryFn: ownerApi.getBlocked });
  if (query.isPending) return <Spinner />;
  if (!query.data?.length) return <EmptyState title="No blocked customers" hint="Customers with repeated no-shows appear here." />;
  return (
    <div className="space-y-2">
      {query.data.map((c) => (
        <div key={c.phone} className="flex items-center justify-between rounded-xl border border-border bg-card p-4">
          <div><p className="font-medium">{c.customer_name || c.phone}</p><p className="text-xs text-muted-foreground">{c.phone} · {c.no_show_strikes} strikes</p></div>
          <button onClick={() => ownerApi.unblockCustomer(c.phone).then(() => { queryClient.invalidateQueries({ queryKey: ["ownerBlocked"] }); toast.success("Unblocked"); })} className="rounded-full bg-primary px-4 py-1.5 text-xs font-semibold text-primary-foreground">Unblock</button>
        </div>
      ))}
    </div>
  );
}
